import { render, staticRenderFns } from "./ExamsSection.vue?vue&type=template&id=981bbb06&scoped=true"
import script from "./ExamsSection.vue?vue&type=script&lang=js"
export * from "./ExamsSection.vue?vue&type=script&lang=js"
import style0 from "./ExamsSection.vue?vue&type=style&index=0&id=981bbb06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981bbb06",
  null
  
)

export default component.exports